import { Container } from "routes/patients/PatientProfile/components/UserCourse/components/LibraryItem/LibraryItem";

import { SkeletonLayout } from "../SkeletonLayout";

const thumbnail = { type: "skeleton", variant: "rounded", width: 80, height: 80 } as const;

const title = { type: "skeleton", variant: "text", typographyVariant: "body_bold", width: "70%" } as const;
const caption = { type: "skeleton", variant: "text", typographyVariant: "subtitle1", width: "30%" } as const;
const tag = { type: "skeleton", variant: "rounded", width: 60, height: 22 } as const;

const authorAvatar = { type: "skeleton", variant: "circular", width: 32, height: 32 } as const;
const authorName = { type: "skeleton", variant: "text", typographyVariant: "subtitle2", width: 100 } as const;

export const LibraryItemSkeleton: React.FC = () => {
  return (
    <Container $disabled>
      <SkeletonLayout
        layout={{
          type: "column",
          gap: 2.5,
          children: [
            {
              type: "row",
              gap: 1.5,
              children: [
                thumbnail,
                {
                  type: "column",
                  flex: 1,
                  gap: 0.5,
                  children: [title, caption, { type: "row", gap: 0.5, marginTop: 1, children: [tag, tag] }],
                },
              ],
            },
            { type: "row", gap: 1, alignItems: "center", children: [authorAvatar, authorName] },
          ],
        }}
      />
    </Container>
  );
};
